/** @jsx jsx */
import { jsx, Heading, Link as TLink } from "theme-ui"
import { Link } from "gatsby"
import { Flex } from "@theme-ui/components"
import Layout from "./layout"
import ProjectsListing from "./projects-listing"
import SEO from "@lekoarts/gatsby-theme-minimal-blog/src/components/seo"

type ProjectsProps = {
  projects: {
    slug: string
    title: string
    excerpt: string
  }[]
}[]


const ProjectsPage = ({data}) => {
  const projects = data.allProject.nodes
  return (
    <Layout>
      <SEO title="Projects" />
      <ProjectsListing projects={projects} sx={{ mt: [4, 5] }} />
    </Layout>
  )
}

export default ProjectsPage
